import { render, staticRenderFns } from "./script_info.vue?vue&type=template&id=2fd3a91d"
import script from "./script_info.vue?vue&type=script&lang=js"
export * from "./script_info.vue?vue&type=script&lang=js"
import style0 from "./script_info.vue?vue&type=style&index=0&id=2fd3a91d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports